import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BorrowerState } from 'ng2-app/store/borrower/borrower/borrower.state';
import { Observable, Subject, combineLatest, filter, map, takeUntil } from 'rxjs';
import { Borrower } from 'lendio-borrower/models/borrower/borrower.model';
import { GetContactsForBorrower } from 'app/store/contact/contact.actions';
import { GetNonOwnerPersonnelForBorrower } from 'app/store/non-owner-personnel/non-owner-personnel.actions';
import { ContactState } from 'app/store/contact/contact.state';
import { Contact } from 'app/models/contact/contact.model';
import { NonOwnerPersonnelState } from 'app/store/non-owner-personnel/non-owner-personnel.state';
import { isDefined } from 'app/modules/shared/functions/filters';

@Component({
  selector: 'app-borrower-pane-overview',
  templateUrl: './borrower-pane-overview.component.html',
  styleUrls: ['./borrower-pane-overview.component.scss'],
  standalone: false
})
export class BorrowerPaneOverviewComponent implements OnInit, OnDestroy {

  @Select(BorrowerState.borrower) borrower$: Observable<Borrower>;
  @Select(ContactState.contacts) contacts$: Observable<Contact[]>;
  @Select(NonOwnerPersonnelState.nonOwnerPersonnel) nonOwnerContacts$: Observable<Contact[]>;
  @ViewChild('businessPersonnel') businessPersonnelRef: ElementRef;
  @ViewChild('businessDetails') businessDetailsRef: ElementRef;
  @ViewChild('businessContact') businessContactRef: ElementRef;
  @ViewChild('monthlyTotals') monthlyTotalsRef: ElementRef;

  allContacts$: Observable<Contact[]>;
  destroyed$ = new Subject<boolean>();

  detailFields = [
    'doingBusinessAsName',
    'number_of_employees',
    'acceptsCredit',
    'monthlyCharges',
    'lendioIndustry',
    'percentOwnership',
    'authorizedOwner',
    'annual_profits',
    'annualRevenue',
    'entity_type'
  ];

  contactFields = [
    'borrowerPhone',
    'borrowerCanText',
    'marketingSmsOptIn',
    'borrowerStreet',
    'borrowerCity',
    'borrowerState',
    'borrowerZip',
  ];

  contactAttributeExcludes = [
    'Percent Ownership',
    'Title',
  ];

  constructor(
    private store: Store
  ) { }

  ngOnInit(): void {
    this.borrower$.pipe(
      filter(isDefined),
      takeUntil(this.destroyed$)
    ).subscribe( borrower => {
      this.store.dispatch( new GetContactsForBorrower(borrower.id) );
      this.store.dispatch( new GetNonOwnerPersonnelForBorrower(borrower.id) );
    });

    this.allContacts$ = combineLatest([this.contacts$, this.nonOwnerContacts$]).pipe(
      map(([contacts, nonOwners]) => [...contacts, ...nonOwners])
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  scrollToContent(element) {
    switch(element) {
      case 'businessPersonnel': {
        this.businessPersonnelRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        break;
      }
      case 'businessDetails': {
        this.businessDetailsRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        break;
      }
      case 'businessContact': {
        this.businessContactRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        break;
      }
      case 'monthlyTotals': {
        this.monthlyTotalsRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        break;
      }
      default: {
        break;
      }
    }
  }

}
